<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Parameter Monitoring &nbsp;
          <add-button
            link="/planned-maintenance/parameter-monitorings/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Management</li>
          <li class="breadcrumb-item">Parameter Monitoring</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body row">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
          <!-- Export To Excel -->
          <div class="col-md-4">
            <div style="float: right">
              <a
                href="#"
                class="btn btn-primary"
                v-if="ExportparameterMonitoring.length == 0"
                @click="exportToExcel"
              >
                <span v-if="isExcelloading">
                  <div class="d-flex align-items-center">
                    <strong>Generating Excel</strong>
                    &nbsp;
                    <div
                      class="
                        spinner-border
                        text-light
                        spinner-border-sm
                        ms-auto
                      "
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                </span>
                <span v-else>Generate Excel</span>
              </a>
              <download-excel
                :title="title"
                v-else
                class="btn btn-success"
                :data="parameterMonitoring_excel"
                :fields="excel_fields"
                worksheet="Parameter Monitoring"
                name="Parameter Monitoring.xls"
                >Download Excel
              </download-excel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Parameter</th>
                    <th>Reading date</th>
                    <th>Comments</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="parameterMonitoring.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(parameterMonitoring, at) in parameterMonitoring"
                    :key="`parameterMonitoring${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>
                      {{
                        parameterMonitoring.parameter_setup
                          ? parameterMonitoring.parameter_setup.title
                          : ""
                      }}
                    </td>
                    <td>{{ parameterMonitoring.reading_date | ddmmyyyy }}</td>
                    <td>
                      {{ parameterMonitoring.comments }}
                    </td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/parameter-monitorings/${parameterMonitoring.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(parameterMonitoring.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "parameterMonitoring",
  data() {
    return {
      parameterMonitoring: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      parameterMonitoring_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Parameter: "parameter",
        "Reading Date": "reading_date",
        Comments: "comments",
      },
      ExportparameterMonitoring: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let parameterMonitoring = await axios.get(
        `/parameter_monitorings?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.parameterMonitoring = parameterMonitoring.data.data;
      this.count = parameterMonitoring.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let parameterMonitoring = await axios.get(
        `/parameter_monitorings?search=${this.searchData}`
      );
      this.parameterMonitoring = parameterMonitoring.data.data;
      this.count = parameterMonitoring.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Parameter Setup Data";
      this.parameterMonitoring_excel = [];
      let ExportparameterMonitoring = [];
      ExportparameterMonitoring = await axios.get(`/parameter_monitorings`);
      this.ExportparameterMonitoring = ExportparameterMonitoring.data.data;
      let sr_no = 1;
      this.ExportparameterMonitoring.forEach((parameterMonitoring) => {
        this.parameterMonitoring_excel.push({
          sr_no: sr_no,
          parameter: parameterMonitoring.parameter_setup
            ? parameterMonitoring.parameter_setup.title
            : "",
          reading_date: parameterMonitoring
            ? parameterMonitoring.reading_date
            : "",
          comments: parameterMonitoring ? parameterMonitoring.comments : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=parameter_monitorings`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
